import React from 'react';

const contests = [
  { id: 2, title: 'Flash Contest: Double points on fuel sales', reward: '2x points', endsIn: '1 hr' }
];

const Contests = () => {
  return (
    <div className="max-w-4xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
      <h1 className="text-2xl font-bold mb-4">Contests & Challenges</h1>

      <div className="grid grid-cols-1 gap-4">
        {contests.map(c => (
          <div key={c.id} className="bg-white rounded-lg shadow p-4 flex justify-between items-center">
            <div>
              <div className="text-sm font-medium">{c.title}</div>
              <div className="text-xs text-gray-500">Reward: {c.reward}</div>
            </div>
            <div className="text-xs text-gray-500">{c.endsIn}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Contests;